module.exports = __webpack_public_path__ + "img/9788952210661.9054aed0.jpg";